
import { FSharpRef, Union, Record } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { list_type, union_type, record_type, option_type, class_type, decimal_type, int32_type, bool_type, string_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { ChallengeStatus, ChallengeStatus_$reflection } from "../Challenge.js";
import { join, printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { gap_gap$002D6, grid_cols$002D3, grid_cols$002D1, cursor_cursorPointer, transition_transitionShadow, boxShadow_shadowLg, padding_p6, boxShadow_shadowMd, borderRadius_roundedLg, borderWidth_borderT, padding_pt4, gap_gap$002D4, grid_cols$002D2, display_grid, gap_gap$002D1, display_inlineFlex, gap_gap$002D3, margin_mt1, fontWeight_fontSemibold, fontSize_textLg, margin_mb4, alignItems_itemsStart, textColor_white, position_relative, margin_mt3, fontWeight_fontMedium, borderRadius_roundedMd, padding_py1, padding_px3, gap_gap$002D2, justifyContent_justifyCenter, alignItems_itemsCenter, duration_duration300, transition_transitionAll, height_h2, margin_mb1, fontSize_textSm, justifyContent_justifyBetween, display_flex, width_wFull } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { lg, md, backgroundColor_bgSurface, FocusVisible_ring, textColor_textPrimary600, borderColor_borderNeutral100, textColor_textNeutral500, textColor_textNeutral900, backgroundColor_bgSecondary700, backgroundColor_bgSecondary600, backgroundColor_bgPrimary700, textColor_textOnPrimary, backgroundColor_bgStatusPublishedActionHover, hover, backgroundColor_bgStatusPublishedAction, backgroundColor_bgPrimary600, borderRadius_roundedFull, backgroundColor_bgNeutral200, textColor_textNeutral600, tw } from "../TailwindExtensions.js";
import { append as append_1, cons, singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { createElement } from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { tryParse } from "../../fable_modules/fable-library-js.5.3.0/Guid.js";
import { tryFind } from "../../fable_modules/fable-library-js.5.3.0/Map.js";
import { map as map_1, collect, empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { render as render_1 } from "./StatusBadge.js";
import { equals } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { fromParts, toString } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { bind, map } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { pledgeIndicatorBadge, classifyIndicator } from "../Pledge/PledgeIndicatorBadge.js";
import { PageErrorKind, pageErrorContent, emptyStateFull, skeletonChallengeCard } from "../Layout/Interactions.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.3.0/Range.js";
import { TailwindHelpers_buttonPrimary } from "../Layout/Layout.js";
import { now, addDays } from "../../fable_modules/fable-library-js.5.3.0/Date.js";

export class ChallengeDisplay extends Record {
    constructor(Id, Title, Theme, Status, FeePaid, DaysCompleted, TotalDays, PledgeCount, TotalPledged, TotalRaised, TargetAmount, Unit, StartDate, EndDate, Timezone) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Theme = Theme;
        this.Status = Status;
        this.FeePaid = FeePaid;
        this.DaysCompleted = (DaysCompleted | 0);
        this.TotalDays = (TotalDays | 0);
        this.PledgeCount = (PledgeCount | 0);
        this.TotalPledged = TotalPledged;
        this.TotalRaised = TotalRaised;
        this.TargetAmount = TargetAmount;
        this.Unit = Unit;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Timezone = Timezone;
    }
}

export function ChallengeDisplay_$reflection() {
    return record_type("Shared.ChallengeList.ChallengeDisplay", [], ChallengeDisplay, () => [["Id", string_type], ["Title", string_type], ["Theme", string_type], ["Status", ChallengeStatus_$reflection()], ["FeePaid", bool_type], ["DaysCompleted", int32_type], ["TotalDays", int32_type], ["PledgeCount", int32_type], ["TotalPledged", decimal_type], ["TotalRaised", decimal_type], ["TargetAmount", decimal_type], ["Unit", string_type], ["StartDate", class_type("System.DateTime")], ["EndDate", option_type(class_type("System.DateTime"))], ["Timezone", string_type]]);
}

export class CardAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PayFee", "Publish", "Manage", "NoAction"];
    }
}

export function CardAction_$reflection() {
    return union_type("Shared.ChallengeList.CardAction", [], CardAction, () => [[["challengeId", string_type]], [["challengeId", string_type]], [["challengeId", string_type]], []]);
}

export class BrowseCardAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Pledge", "ViewOnly"];
    }
}

export function BrowseCardAction_$reflection() {
    return union_type("Shared.ChallengeList.BrowseCardAction", [], BrowseCardAction, () => [[["challengeId", string_type]], []]);
}

export class ListState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Loading", "Empty", "Loaded", "Error"];
    }
}

export function ListState_$reflection() {
    return union_type("Shared.ChallengeList.ListState", [], ListState, () => [[], [], [["Item", list_type(ChallengeDisplay_$reflection())]], [["Item", string_type]]]);
}

function formatCurrency(amount) {
    return toText(printf("$%.2f"))(amount);
}

function calculateProgress(completed, total) {
    if (total === 0) {
        return 0;
    }
    else {
        return (completed / total) * 100;
    }
}

function progressBar(completed, total) {
    const percentage = calculateProgress(completed, total);
    return HtmlHelper_createElement("div", ofArray([["className", width_wFull], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, fontSize_textSm, textColor_textNeutral600, margin_mb1]))], ["children", [HtmlHelper_createElement("span", singleton(["children", singleton(`Day ${completed} of ${total}`)])), HtmlHelper_createElement("span", singleton(["children", singleton(`${~~percentage}%`)]))]]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([width_wFull, backgroundColor_bgNeutral200, borderRadius_roundedFull, height_h2]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([backgroundColor_bgPrimary600, height_h2, borderRadius_roundedFull, transition_transitionAll, duration_duration300]))], ["style", {
        width: percentage + "%",
    }]]))]]]))]]]));
}

export function cardAction(challenge) {
    const matchValue = challenge.Status;
    let matchResult;
    switch (matchValue.tag) {
        case 2:
        case 3:
        case 4:
        case 5: {
            matchResult = 4;
            break;
        }
        case 6:
        case 7: {
            matchResult = 5;
            break;
        }
        case 1: {
            if (!challenge.FeePaid) {
                matchResult = 2;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        default:
            if (!challenge.FeePaid) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
    }
    switch (matchResult) {
        case 0:
            return new CardAction(0, [challenge.Id]);
        case 1:
            return new CardAction(1, [challenge.Id]);
        case 2:
            return new CardAction(0, [challenge.Id]);
        case 3:
            return new CardAction(1, [challenge.Id]);
        case 4:
            return new CardAction(2, [challenge.Id]);
        default:
            return new CardAction(3, []);
    }
}

export function browseCardAction(_challenge) {
    return new BrowseCardAction(1, []);
}

function ctaButton(action, onAction) {
    const buttonBase = tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, gap_gap$002D2, padding_px3, padding_py1, borderRadius_roundedMd, fontSize_textSm, fontWeight_fontMedium, width_wFull, margin_mt3, position_relative, "z-[1]"]));
    switch (action.tag) {
        case 1:
            return HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([buttonBase, backgroundColor_bgStatusPublishedAction, textColor_white, hover(backgroundColor_bgStatusPublishedActionHover)]))], ["children", [createElement(icon, {
                name: new IconName(2, []),
                size: new IconSize(1, []),
                weight: new IconWeight(0, []),
            }), HtmlHelper_createElement("span", singleton(["children", singleton("Publish")]))]], ["onClick", (e_1) => {
                e_1.stopPropagation();
                onAction(action);
            }]]));
        case 2:
            return HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([buttonBase, backgroundColor_bgPrimary600, textColor_textOnPrimary, hover(backgroundColor_bgPrimary700)]))], ["children", [createElement(icon, {
                name: new IconName(45, []),
                size: new IconSize(1, []),
                weight: new IconWeight(0, []),
            }), HtmlHelper_createElement("span", singleton(["children", singleton("Manage")]))]], ["onClick", (e_2) => {
                e_2.stopPropagation();
                onAction(action);
            }]]));
        case 3:
            return defaultOf();
        default:
            return HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([buttonBase, backgroundColor_bgSecondary600, textColor_white, hover(backgroundColor_bgSecondary700)]))], ["children", [createElement(icon, {
                name: new IconName(44, []),
                size: new IconSize(1, []),
                weight: new IconWeight(0, []),
            }), HtmlHelper_createElement("span", singleton(["children", singleton("Pay Fee")]))]], ["onClick", (e) => {
                e.stopPropagation();
                onAction(action);
            }]]));
    }
}

function browseCta(action, onAction) {
    const buttonBase = tw(ofArray([padding_px3, padding_py1, borderRadius_roundedMd, fontSize_textSm, fontWeight_fontMedium, width_wFull, margin_mt3, position_relative, "z-[1]"]));
    if (action.tag === 1) {
        return defaultOf();
    }
    else {
        return HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([buttonBase, backgroundColor_bgPrimary600, textColor_textOnPrimary, hover(backgroundColor_bgPrimary700)]))], ["children", singleton("Pledge")], ["onClick", (e) => {
            e.stopPropagation();
            onAction(action);
        }]]));
    }
}

function lookupPledge(pledgeLookup, challengeId) {
    let matchValue;
    let outArg = "00000000-0000-0000-0000-000000000000";
    matchValue = [tryParse(challengeId, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return tryFind(matchValue[1], pledgeLookup);
    }
    else {
        return undefined;
    }
}

function borderAccentClass(variant) {
    switch (variant.tag) {
        case 1:
            return "border-warning-300";
        case 2:
            return "border-neutral-400";
        case 3:
            return "border-success-600";
        case 4:
            return "border-neutral-400";
        case 5:
            return "border-neutral-400";
        default:
            return "border-primary-600";
    }
}

function cardBody(challenge, ctaElement) {
    return toList(delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, alignItems_itemsStart, margin_mb4]))], ["children", [HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton(challenge.Title)]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton(challenge.Theme)]]))]])), render_1(challenge.Status)]]]))), delay(() => append(((equals(challenge.Status, new ChallengeStatus(4, [])) ? true : equals(challenge.Status, new ChallengeStatus(5, []))) ? true : equals(challenge.Status, new ChallengeStatus(6, []))) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", margin_mb4], ["children", [progressBar(challenge.DaysCompleted, challenge.TotalDays)]]]))) : empty(), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D3, fontSize_textSm, textColor_textNeutral500, margin_mb4]))], ["children", [HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D1]))], ["children", [createElement(icon, {
        name: new IconName(43, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("span", toList(delay(() => singleton_1(["children", singleton(`${challenge.PledgeCount} ${(challenge.PledgeCount === 1) ? "pledger" : "pledgers"}`)]))))]]]))]]]))), delay(() => {
        let arg;
        return append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_grid, grid_cols$002D2, gap_gap$002D4, padding_pt4, borderWidth_borderT, borderColor_borderNeutral100]))], ["children", [HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-1.5", fontSize_textSm, textColor_textNeutral500]))], ["children", [createElement(icon, {
            name: new IconName(42, []),
            size: new IconSize(0, []),
            weight: new IconWeight(0, []),
        }), HtmlHelper_createElement("span", singleton(["children", singleton(equals(challenge.Status, new ChallengeStatus(6, [])) ? "Raised" : "Pledged")]))]]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textPrimary600]))], ["children", singleton(formatCurrency(equals(challenge.Status, new ChallengeStatus(6, [])) ? challenge.TotalRaised : challenge.TotalPledged))]]))]])), HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-1.5", fontSize_textSm, textColor_textNeutral500]))], ["children", [createElement(icon, {
            name: new IconName(17, []),
            size: new IconSize(0, []),
            weight: new IconWeight(0, []),
        }), HtmlHelper_createElement("span", singleton(["children", singleton("Target")]))]]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton((arg = toString(challenge.TargetAmount), toText(printf("%s %s"))(arg)(challenge.Unit)))]]))]]))]]]))), delay(() => singleton_1(ctaElement)));
    }))))))));
}

function cardWrapper(borderAccent, onChallengeSelect, challenge, children) {
    const stretchedLink = HtmlHelper_createElement("a", ofArray([["href", toText(printf("/challenges/%s"))(challenge.Id)], ["className", tw(ofArray(["absolute", "inset-0", FocusVisible_ring]))], ["aria-label", challenge.Title], ["onClick", (e) => {
        e.preventDefault();
        onChallengeSelect(challenge.Id);
    }]]));
    return HtmlHelper_createElement("article", ofArray([["className", tw(toList(delay(() => append(singleton_1("relative"), delay(() => append(singleton_1(backgroundColor_bgSurface), delay(() => append(singleton_1(borderRadius_roundedLg), delay(() => append(singleton_1(boxShadow_shadowMd), delay(() => append(singleton_1(padding_p6), delay(() => append(singleton_1(hover(boxShadow_shadowLg)), delay(() => append(singleton_1(transition_transitionShadow), delay(() => append(singleton_1(cursor_cursorPointer), delay(() => {
        const matchValue = borderAccent;
        if (matchValue == null) {
            return empty();
        }
        else {
            const accent = matchValue;
            return append(singleton_1("border-l-4"), delay(() => singleton_1(accent)));
        }
    })))))))))))))))))))], ["children", cons(stretchedLink, children)]]));
}

function challengeCard(onChallengeSelect, onAction, challenge) {
    return cardWrapper(undefined, onChallengeSelect, challenge, cardBody(challenge, ctaButton(cardAction(challenge), onAction)));
}

function browseChallengeCard(pledgeLookup, onChallengeSelect, onAction, challenge) {
    const pledgeOpt = lookupPledge(pledgeLookup, challenge.Id);
    const accent = map(borderAccentClass, bind(classifyIndicator, pledgeOpt));
    const badge = pledgeIndicatorBadge(pledgeOpt);
    return cardWrapper(accent, onChallengeSelect, challenge, append_1(cardBody(challenge, browseCta(browseCardAction(challenge), onAction)), singleton(badge)));
}

const loadingState = HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading challenges"], ["className", tw(ofArray([display_grid, grid_cols$002D1, md(grid_cols$002D2), lg(grid_cols$002D3), gap_gap$002D6]))], ["children", toList(delay(() => collect((matchValue) => singleton_1(HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["children", [skeletonChallengeCard()]]]))), rangeDouble(1, 1, 3))))]]));

function emptyState(onCreateChallenge) {
    return emptyStateFull(new IconName(17, []), "You haven\'t created any challenges yet.", "Get started by creating your first challenge.", "Create Your First Challenge", onCreateChallenge);
}

function errorState(message, onRetry) {
    return pageErrorContent(new PageErrorKind(1, [message]), singleton(HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", TailwindHelpers_buttonPrimary], ["children", singleton("Try Again")], ["onClick", (_arg) => {
        onRetry();
    }]]))), undefined, undefined, 2);
}

export function render(state, onCreateChallenge, onRetry, onChallengeSelect, onCardAction) {
    return HtmlHelper_createElement("div", ofArray([["className", width_wFull], ["children", toList(delay(() => ((state.tag === 1) ? singleton_1(emptyState(onCreateChallenge)) : ((state.tag === 3) ? singleton_1(errorState(state.fields[0], onRetry)) : ((state.tag === 2) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_grid, grid_cols$002D1, md(grid_cols$002D2), lg(grid_cols$002D3), gap_gap$002D6]))], ["children", toList(delay(() => map_1((challenge) => challengeCard(onChallengeSelect, onCardAction, challenge), state.fields[0])))]]))) : singleton_1(loadingState))))))]]));
}

const browseEmptyState = emptyStateFull(new IconName(46, []), "No challenges available yet", "Check back soon!", undefined, undefined);

export function renderBrowse(state, onRetry, onChallengeSelect, onBrowseAction, pledgeLookup) {
    return HtmlHelper_createElement("div", ofArray([["data-testid", "browse-challenges-section"], ["className", width_wFull], ["children", toList(delay(() => ((state.tag === 1) ? singleton_1(browseEmptyState) : ((state.tag === 3) ? singleton_1(errorState(state.fields[0], onRetry)) : ((state.tag === 2) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_grid, grid_cols$002D1, md(grid_cols$002D2), lg(grid_cols$002D3), gap_gap$002D6]))], ["children", toList(delay(() => map_1((challenge) => browseChallengeCard(pledgeLookup, onChallengeSelect, onBrowseAction, challenge), state.fields[0])))]]))) : singleton_1(loadingState))))))]]));
}

export const sampleChallenges = ofArray([new ChallengeDisplay("1", "30-Day Running Challenge", "Run 5km every day", new ChallengeStatus(4, []), true, 12, 30, 5, fromParts(24550, 0, 0, false, 2), fromParts(0, 0, 0, false, 0), fromParts(50000, 0, 0, false, 2), "km", addDays(now(), -12), undefined, "UTC"), new ChallengeDisplay("2", "Read 20 Books", "One book per week", new ChallengeStatus(6, []), true, 20, 20, 8, fromParts(38000, 0, 0, false, 2), fromParts(28000, 0, 0, false, 2), fromParts(30000, 0, 0, false, 2), "books", addDays(now(), -140), addDays(now(), -20), "UTC"), new ChallengeDisplay("3", "Meditation Marathon", "Meditate for 30 minutes daily", new ChallengeStatus(1, []), false, 0, 21, 0, fromParts(0, 0, 0, false, 2), fromParts(0, 0, 0, false, 0), fromParts(20000, 0, 0, false, 2), "sessions", addDays(now(), 5), undefined, "UTC")]);

//# sourceMappingURL=ChallengeList.js.map
